"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = exports.Button = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _Loader = _interopRequireDefault(require("../Loader"));
var _styles = require("../../utils/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const rippleEffect = (activeBgColor, hoverBgColor) => (0, _styledComponents.css)`
  background-position: center;
  transition: background 0.8s;

  &:enabled {
    &:hover {
      background:
        ${hoverBgColor}
        radial-gradient(circle, transparent 0.1%, ${hoverBgColor} 0.1%)
        center/150000%;
    }

    &:active {
      background-color: ${activeBgColor};
      background-size: 100%;
      transition: background 0s;
    }
  }
`;
const variantStyles = theme => ({
  primary: (0, _styledComponents.css)`
    background-color: ${theme.colors.buttonBackground};
    color: ${theme.colors.buttonText};

    ${rippleEffect((0, _polished.lighten)(0.1, theme.colors.buttonBackground), (0, _polished.darken)(0.05, theme.colors.buttonBackground))}
  `,
  secondary: (0, _styledComponents.css)`
    background-color: ${theme.colors.silverGrey};
    color: ${theme.colors.primaryDark};

    ${rippleEffect((0, _polished.lighten)(0.07, theme.colors.silverGrey), (0, _polished.darken)(0.06, theme.colors.silverGrey))}
  `
});
const Button = _styledComponents.default.button`
  ${({
  $loading,
  variant,
  theme
}) => (0, _styledComponents.css)`
    align-items: center;
    cursor: pointer;
    display: flex;
    font-family: ${theme.fonts.family.montserrat};
    font-size: ${theme.fonts.sizes.medium};
    font-weight: ${theme.fonts.weight.bold};
    justify-content: center;
    line-height: 1;
    min-height: 4.9rem;
    min-width: 13.2rem;
    padding: 1.4rem 3.8rem;
    text-transform: uppercase;

    ${_styles.userSelectNone}

    ${$loading && (0, _styledComponents.css)`
      span {
        color: transparent;
      }
    `}

    &:disabled {
      cursor: auto;
      ${!$loading && (0, _styledComponents.css)`
        opacity: 0.4;
      `}
    }

    ${variantStyles(theme)[variant]}
  `}
`;
exports.Button = Button;
const Loader = (0, _styledComponents.default)(_Loader.default)`
  position: absolute;
`;
exports.Loader = Loader;